import { useCallback } from 'react'
import Link from '@mui/material/Link'
import GenericDropdown from '../../generic/genericDropdown'
import { backendDeleteWithoutRefresh } from '../../../helpers/callBackend'
import { errorMessage } from '../../../helpers/errorMessageFunc'

const ReportRunRowDropdown = ({ reportId, reportRunInfo, removeRuns }) => {
  const handleDelete = useCallback(async () => {
    try {
      const runResp = await backendDeleteWithoutRefresh('/api/reports/v2/report-builder-run/', {
        report_builder_id: reportId,
        run_date: reportRunInfo.run_date,
      })
      if (runResp.status === 200) {
        removeRuns([reportRunInfo.run_date])
      }
    } catch (error) {
      errorMessage(error.message)
    }
  }, [reportRunInfo])

  const dropdownItems = [
    <Link component='button' color='error' underline='none' onClick={handleDelete}>
      Delete
    </Link>,
  ]

  return <GenericDropdown dropdownItems={dropdownItems} />
}

export default ReportRunRowDropdown
